import React from "react";
import { Dimmer, Loader, Sidebar } from "semantic-ui-react";
import {
  Route,
  Redirect,
  Switch,
  HashRouter,
  useHistory,
} from "react-router-dom";
import { Plant_Overview_COMMON, Sign_In } from "./constants/pages";
import HeaderMenu from "./components/Header/HeaderMenu";
import SidebarMenu from "./components/Header/SidebarMenu";

import { connect, useSelector, useDispatch } from "react-redux";
import {
  setHasAppReceived,
  setHasHeaderReceived,
  setHeaderValues,
  setModel,
  setOperateVersion,
  setUserArray,
  setIsWarningAL,
} from "./actions/headerActions";
import { socket } from "./lib/socketio";
import {
  showSidebarMenu,
  setUser,
  setUserCopy,
  setElectronApp,
} from "./actions/navActions";
import AppSettings from "./components/Displays/AppSetting/AppSettings";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faDog } from "@fortawesome/free-solid-svg-icons";
import ErrorPage from "./components/Displays/Error/ErrorPage";

import { useLocation } from "react-router-dom";

// [UPDATE] toastify
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import RouteList_S300TS from "./routes_S300TS";
import { setFleet } from "./actions/fleetActions";
import { getCredentials, getFleet, getToken, handleError } from "./lib/api";
import * as cookies from "./lib/cookies";
import { setCredentials } from "./lib/credentials";
import SignIn from "./components/Auth/SignIn";
import PPLTDropDown from "./components/LandingPage/Landing";

const App = ({
  setHasAppReceived,
  hasAppReceived,
  setHeaderValues,
  setHasHeaderReceived,
  sidebarVisible,
  showSidebar,
  model,
  setModel,
  setUser,
  user,
}) => {
  const [rev, setRev] = React.useState("");
  const [data, setData] = React.useState();
  const [ids] = React.useState([
    3049, 3050, 3051, 3052, 3053, 3054, 3055, 3056, 3057, 3059, 3060, 3061,
    3062, 6714, 6726, 6727, 6728, 6729, 6730, 6731, 6732, 6734, 6735, 6736,
    6737, 6740, 10628, 10640, 10641, 10642, 10643, 10644, 10645, 10646, 10648,
    10649, 10650, 10651, 10654, 14542, 14554, 14555, 14556, 14557, 14558, 14559,
    14560, 14562, 14563, 14564, 14565, 14568, 18456, 18468, 18469, 18470, 18471,
    18472, 18473, 18474, 18476, 18477, 18478, 18479, 18482, 22370, 22382, 22383,
    22384, 22385, 22386, 22387, 22388, 22390, 22391, 22392, 22393, 22396, 29144
  ]);
  const [routes, setRoutes] = React.useState("");
  const [canTriggerSetting, setCanTriggerSetting] = React.useState(false);
  const [isElectronApp, setIsElectronApp] = React.useState(false);
  const [isDataLayerReady, setIsDataLayerReady] = React.useState(true);
  // update SOFC HMI : dataLayerReady 여러 개 연결여부 확인
  const [eachDataLayerReady, setEachDataLayerReady] = React.useState();
  const [sumDataLayerReady, setSumDataLayerReady] = React.useState(1);

  library.add(faDog);

  // update SOFC HMI :  Main/PSM 구분위한 redux
  const operateVersion = useSelector((state) => state.header.operateVersion);
  const dispatch = useDispatch();

  // update SOFC 240321 by sumin, shortcut bugfix
  const location = useLocation();
  const currentPLC = useSelector((state) => state.header.currentPLC);
  const isToastOn = useSelector((state) => state.sound.isToastOn);

  // // update SOFC 240927, HMI Integrated version
  // const sofcConfig = useSelector((state) => state.header.sofcConfig);

  const ppid = useSelector((state) => state.header.ppid);
  const headerValues = useSelector((state) => state.header.headerValues);
  const userCopy = useSelector((state) => state.nav.userCopy);
  const [authState, setAuthState] = React.useState("loading");
  const [loading, setLoading] = React.useState(false);

  // update SOFC : 첫 렌더링시 단축키 사용안되는 오류 수정 operateVersion 초기값 설정함
  React.useEffect(() => {
    dispatch(setOperateVersion("_PSM1"));
    var userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.indexOf(" electron/") > -1) {
      setIsElectronApp(true);
      dispatch(setElectronApp(true));
    }
  }, []);

  // update 240927, HMI Integrated version
  // React.useEffect(() => {
  //     socket.emit('get SOFC Config');
  //     socket.on('receive SOFC Config', (data)=> {
  //         let tempConfig = Object.values(data.display_data[0]).toString();
  //         dispatch(setSofcConfig(tempConfig));
  //         console.log('dispatch');
  //     });

  //     return () => {
  //         socket.removeAllListeners();
  //     };

  // }, [isElectronApp]);

  // update SOFC HMI : dataLayerReady event 추가
  React.useEffect(() => {
    if (
      ids.length > 0 &&
      (typeof data === "undefined" || data === null) &&
      isElectronApp
    ) {
      setTimeout(function () {
        if (!socket.connected) {
          setCanTriggerSetting(true);
        } else {
          socket.emit("get data layer ready", ids);
          socket.on("receive data layer ready", (value) => {
            setIsDataLayerReady(value.result.isDataLayerReady);
          });
          socket.on("receive data layer ready2", (value) => {
            setEachDataLayerReady(value.result);
          });

          return () => {
            socket.removeAllListeners();
          };
        }
      }, 3000);
    }
  }, [isElectronApp]);

  // update SOFC HMI : countDataLayer 계산
  React.useEffect(() => {
    if (
      typeof eachDataLayerReady !== "undefined" ||
      eachDataLayerReady === null
    ) {
      countDataLayer(eachDataLayerReady);
    }
  }, [eachDataLayerReady]);

  // update SOFC HMI : 기존 조건에서 sumDataLayerReady가 0이 아닐때를 추가함
  React.useEffect(() => {
    // if (ids.length > 0 && (typeof data === 'undefined' || data === null) && isDataLayerReady) {
    if (
      ids.length > 0 &&
      (typeof data === "undefined" || data === null) &&
      sumDataLayerReady !== 0
    ) {
      // if(typeof eachDataLayerReady !== 'undefined' || eachDataLayerReady === null ){
      //     countDataLayer(eachDataLayerReady);
      // }
      socket.emit("get header tag values", ids);
      socket.on("receive header tag values", (value) => {
        setData(value.result);
        setHasAppReceived(true);
        setHeaderValues(value.result);
        setHasHeaderReceived(true);
      });
      if (!isElectronApp) {
        socket.on("userArray", (data) => {
          //set global state variable
          dispatch(setUserArray(data));

          // extract the "MMON" group as the default page is the COMMON and only set the roles for this group
          let defaultGroup = data["MMON"];

          //If HMI Server is not Connected to EC2 Server, Alert the User that RMS PC is Disconnected.
          if (
            defaultGroup.length === 1 &&
            defaultGroup[0].split(":")[0] !== "hmi_server"
          ) {
            alert(
              "Connection to the RMS PC is Lost. Data Retrieval is Currently Unavailable!",
            );
          } else if (defaultGroup.length === 2) {
            var second = defaultGroup[1];
            var uname = second.split(":");

            if (user.name === uname[0]) {
              if (userCopy.hmi_role !== user.hmi_role) {
                user.hmi_role = userCopy.hmi_role;
                setUser(user);
              }
            }
          } else {
            for (var i = 2; i < defaultGroup.length; i++) {
              var info = defaultGroup[i].split(":");
              if (user.name === info[0]) {
                user.hmi_role = "E";
                setUser(user);
              }
            }
          }
        });
      }

      return () => {
        socket.removeAllListeners();
      };
    }
  }, [
    isDataLayerReady,
    isElectronApp,
    eachDataLayerReady,
    sumDataLayerReady,
    ppid,
  ]);

  React.useEffect(() => {
    if (typeof data !== "undefined" && data !== null) {
      setRev(convertValue(data["3062"]));
    }
  }, [data]);

  React.useEffect(() => {
    if (rev !== "") {
      setRoutes(RouteList_S300TS());
    }
  }, [rev]);

  // update 240927, HMI integrated version
  // React.useEffect(() => {
  //     if (typeof data !== 'undefined' && data !== null) {
  //         // setRev(convertValue(data['9012']));
  //         setRev(sofcConfig);
  //     }
  // }, [data]);

  // React.useEffect(() => {
  //     if (rev!==''){
  //         setRoutes(assignRoute(rev));
  //     }

  // }, [rev]);

  React.useEffect(() => {
    if (authState === "signedIn") {
      dispatch(setUserCopy(JSON.parse(JSON.stringify(user))));
    }
  }, [authState]);

  React.useEffect(() => {
    let timeout;
    setLoading(true);
    const refreshCredentials = async () => {
      const refreshToken = cookies.getRefreshToken();
      if (refreshToken) {
        try {
          const token = await getToken(refreshToken);
          cookies.setToken(token);
          const { Credentials } = await getCredentials(token.id_token);
          setCredentials(Credentials);
          timeout = setTimeout(
            refreshCredentials,
            new Date(Credentials.Expiration) - new Date() - 60000,
          );
        } catch (err) {
          handleError(err);
        }
      }
    };

    const loadHMI = async () => {
      try {
        let idToken = cookies.getIDToken();
        if (!idToken) {
          const refreshToken = cookies.getRefreshToken();
          if (!refreshToken) {
            throw new Error("offline");
          }
          const token = await getToken(refreshToken);
          cookies.setToken(token);
          idToken = token.id_token;
        }
        const { Credentials, User, Endpoints } = await getCredentials(idToken);
        if (User.role.startsWith("C")) {
          throw new Error("Unauthorized");
        }
        setCredentials(Credentials);

        const [fleet] = await Promise.all([getFleet()]);
        dispatch(setFleet(fleet));
        setUser(User);
        setAuthState("signedIn");
        timeout = setTimeout(
          refreshCredentials,
          new Date(Credentials.Expiration) - new Date() - 60000,
        );
      } catch (err) {
        console.log(err);
        handleError(err);
      } finally {
        // dispatch(endLoading());
        setLoading(false);
      }
    };

    loadHMI();

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  // update SOFC HMI : dataLayerReady 추가
  const countDataLayer = (obj) => {
    let sum = Object.values(obj).reduce((acc, c, i) => {
      return acc + c;
    });
    setSumDataLayerReady(sum);
  };

  // TODO : SOFC_HMI 적용시 추후 수정 필요함.
  const convertValue = (value) => {
    switch (value) {
      case 1:
        return "1";
      case 2:
        return "2";
      case 3:
        if (data["3060"] === 4) return "7";
        else return "3";
      case 4:
        if (data["3060"] === 4 && data["7492"] === 0 && data["7496"] === 1)
          return "8";
        if (data["3060"] === 5 && data["7492"] === 0 && data["7496"] === 1)
          return "9";
        if (data["7492"] === 0 && data["7496"] === 1) return "4";
        if (data["7492"] === 1 && data["7496"] === 0) return "5";
        else return "4";
      case 5:
        return "6";
      default:
        return "3";
    }
  };

  // [UPDATE] shutdown ack alarm sound
  const toastOnClick = () => {
    dispatch(setIsWarningAL(false)); // sound mute
  };

  // TODO : operateVersion에 해당하는 값이 없을 때 error페이지로 넘어가는 것 처리 필요함
  let history = useHistory();

  const getTargetLocation = (pathname, operateVersion) => {
    if (pathname && pathname.includes("PSM")) {
      const base = pathname.slice(1, pathname.indexOf("_PSM"));
      const newPath = `/${base}${operateVersion}`;

      return newPath;
    }
  };

  document.onkeydown = function (e) {
    //@ user credentials
    // if(user && user.username === 'eng'){

    // update SOFC 240318 by sumin, add Shortcut for each PPOperation Page (System team requirement)
    if (e.ctrlKey) {
      if (e.key === "`") {
        e.preventDefault();
        history.push("/PPOperation_MAIN");
        dispatch(setOperateVersion("_MAIN")); //
      } else if (e.key === "1") {
        e.preventDefault();
        history.push("/PPOperation_PSM1");
        dispatch(setOperateVersion("_PSM1"));
      } else if (e.key === "2") {
        e.preventDefault();
        history.push("/PPOperation_PSM2");
        dispatch(setOperateVersion("_PSM2"));
      } else if (e.key === "3") {
        e.preventDefault();
        history.push("/PPOperation_PSM3");
        dispatch(setOperateVersion("_PSM3"));
      } else if (e.key === "4") {
        e.preventDefault();
        history.push("/PPOperation_PSM4");
        dispatch(setOperateVersion("_PSM4"));
      } else if (e.key === "5") {
        e.preventDefault();
        history.push("/PPOperation_PSM5");
        dispatch(setOperateVersion("_PSM5"));
      }
      // update 260316, removed the following shortcut as requested
      // update 260323, Restore previously removed shortcut as requested by the system team
      else if (e.key === "q") {
        // update SOFC 240815 by sumin, add shortcut - plant overview
        e.preventDefault();
        history.push("/PlantOverview_COMMON");
        dispatch(setOperateVersion("_MAIN"));
      }
    }
    // update SOFC 240320 by sumin, add shortcut - control loop (System team reauirement)
    // [UPDATE] FR1.6/2.0 add shortcut - new control loop
    if (e.altKey) {
      if (e.key === "1") {
        e.preventDefault();
        operateVersion.includes("PSM") &&
          history.push(`/CL/AOGRFlow${operateVersion}`);
      }
      // else if(e.key==='2'){
      //     e.preventDefault();
      //     operateVersion.includes('PSM') && history.push(`/CL/AOGRInletTemperature${operateVersion}`);
      else if (e.key === "2") {
        e.preventDefault();
        operateVersion.includes("PSM") &&
          history.push(`/CL/CurrentLimitingDevice${operateVersion}`);
      } else if (e.key === "3") {
        e.preventDefault();
        operateVersion.includes("PSM") &&
          history.push(`/CL/PowerDispatch${operateVersion}`);
      } else if (e.key === "4") {
        e.preventDefault();
        operateVersion.includes("PSM") &&
          history.push(`/CL/ProcessAir${operateVersion}`);
      } else if (e.key === "5") {
        e.preventDefault();
        operateVersion.includes("PSM") &&
          history.push(`/CL/ProcessFuel${operateVersion}`);
      } else if (e.key === "6") {
        e.preventDefault();
        operateVersion.includes("PSM") &&
          history.push(`/CL/StartBurnerFlow${operateVersion}`);
      } else if (e.key === "7") {
        e.preventDefault();
        operateVersion.includes("PSM") &&
          history.push(`/CL/AOGRBlowerMotor${operateVersion}`);
      } else if (e.key === "8") {
        e.preventDefault();
        operateVersion.includes("PSM") &&
          history.push(`/CL/CabinetTemp${operateVersion}`);
      } else if (e.key === "9") {
        e.preventDefault();
        operateVersion.includes("PSM") &&
          history.push(`/CL/CathodeAnodePurge${operateVersion}`);
      } else if (e.key === "0") {
        e.preventDefault();
        operateVersion.includes("PSM") &&
          history.push(`/CL/ReformerTemp${operateVersion}`);
      } else if (e.key === "-") {
        e.preventDefault();
        operateVersion.includes("PSM") &&
          history.push(`/CL/StackFuel${operateVersion}`);
      } else if (e.key === "q") {
        e.preventDefault();
        operateVersion !== "_COMMON" &&
          operateVersion !== "" &&
          history.push(`/ModelActivation${operateVersion}`);
      }
    }

    // [UPDATE] v1.3.3 page navigation shortcuts for PSM
    if (
      currentPLC &&
      currentPLC.includes("PSM") &&
      operateVersion &&
      operateVersion.includes("_PSM")
    ) {
      if (e.key === "Tab") {
        e.preventDefault();
        history.push(getTargetLocation(location.pathname, operateVersion));
      }
    }

    switch (e.key) {
      case "ArrowLeft": // left
        history.goBack();
        break;
      case "ArrowRight": // right
        history.goForward();
        break;
      case "F1":
        showSidebar();
        break;
      case "F2": // update SOFC 240320 by sumin, PAFC : Model Activation -> SOFC : Calculated Parameters (system team)
        operateVersion !== "_COMMON" &&
          operateVersion !== "" &&
          history.push(`/CP/CalcParms${operateVersion}`);
        break;
      case "F3": // update S300TS Version
        operateVersion !== "_COMMON" &&
          operateVersion !== "" &&
          history.push(`/PCS_Overview_S300${operateVersion}`);
        break;
      case "F4": // update 241220, S300 Test Stand Only
        // if(sofcConfig === 'marine'){
        //     (operateVersion !== '_COMMON' && operateVersion !== "") && history.push(`/IO/DigitalIO_Marine${operateVersion}`);
        // }else{
        //     (operateVersion !== '_COMMON' && operateVersion !== "") && history.push(`/IO/DigitalIO${operateVersion}`);
        // }
        // (operateVersion !== '_COMMON' && operateVersion !== "") && history.push(`/IO/DigitalIO_Marine${operateVersion}`);
        operateVersion !== "" && operateVersion.includes("PSM")
          ? history.push(`/IO/DigitalIO${operateVersion}`)
          : history.push("/IO/DigitalIO_MAIN");
        break;
      case "F5": // update SOFC 240927, HMI Integrated version
        // if(sofcConfig === 'marine'){
        //     (operateVersion !== '_COMMON' && operateVersion !== "") && history.push(`/IO/AnalogIO_Marine${operateVersion}`);
        // }else{
        //     (operateVersion !== '_COMMON' && operateVersion !== "") && history.push(`/IO/AnalogIO${operateVersion}`);
        // }
        // (operateVersion !== '_COMMON' && operateVersion !== "") && history.push(`/IO/AnalogIO_Marine${operateVersion}`);
        operateVersion !== "" && operateVersion.includes("PSM")
          ? history.push(`/IO/AnalogIO${operateVersion}`)
          : history.push("/IO/AnalogIO_MAIN");
        break;
      case "F6": // Main, PSM
        operateVersion !== "_COMMON" &&
          operateVersion !== "" &&
          history.push(`/PPOperation${operateVersion}`);
        break;
      case "F7": // Main, PSM
        operateVersion !== "_COMMON" &&
          history.push(`/Events${operateVersion}`);
        break;
      case "F8": // update SOFC 240320 by sumin, PAFC : CVS, SOFC : MAIN-SVM IO, PSM-PSM Overview, S300TS version
        if (operateVersion !== "" && operateVersion.includes("PSM")) {
          // sofcConfig === 'marine' ? history.push(`/PSM_Overview_Marine${operateVersion}`) :
          // update S300TS Version
          history.push(`/PSM_Overview_S300${operateVersion}`);
        } else if (operateVersion !== "" && operateVersion === "_MAIN") {
          history.push("/IO/SVMIO_MAIN");
        }
        break;
      case "F9": // update SOFC 240320 by sumin, PAFC : TMS, SOFC : MAIN - PSM IO, PSM - Stack Overview
        // history.push('/TMS_MAIN');
        if (operateVersion.includes("PSM")) {
          // update 240927, HMI Integrated Version
          history.push(`/Stack_S300${operateVersion}`);
        } else if (operateVersion === "_MAIN") {
          history.push("/IO/PSMIO_MAIN");
        }
        break;
      case "F10": // update SOFC 240320 by sumin, PA : Parameter Reset -> SOFC : VSD Feedback
        operateVersion !== "_COMMON" &&
          operateVersion !== "" &&
          history.push(`/IO/VSDFeedback${operateVersion}`);
        break;
      case "F11": // MAIN, PSM
        operateVersion !== "_COMMON" &&
          operateVersion !== "" &&
          history.push(`/Interlocks${operateVersion}`);
        break;
      case "F12": // MAIN, PSM
        operateVersion !== "_COMMON" &&
          operateVersion !== "" &&
          history.push(`/SeqOverrides${operateVersion}`);
        break;
      case "Home":
        e.preventDefault();
        history.push("/PlantOverview_COMMON");
        dispatch(setOperateVersion("_MAIN"));
        break;
      // [UPDATE] v1.3.3 page navigation shortcuts for PSM
      case "Tab":
        e.preventDefault();
        break;

      default:
        return; // exit this handler for other keys
    }
    e.preventDefault(); // prevent the default
  };


  // update SOFC HMI : sumDataLayerReady가 0 일때 Errorpage로 넘어가게 수정
  return (
    <>
      {canTriggerSetting ? (
        <AppSettings
          addHeader={"Connection Issue. Please Choose The Unit To Connect To."}
        />
      ) : // !isDataLayerReady ?
      sumDataLayerReady === 0 ? (
        <ErrorPage />
      ) : (
        <>
          <Dimmer active={loading}>
            <Loader size="massive" content="Loading HMI" />
          </Dimmer>
          <HashRouter>
            <Switch>
              {isElectronApp ? (
                <>
                  <Redirect exact from="/" to={Plant_Overview_COMMON.path} />
                  <Route
                    render={() =>
                      routes.length > 0 && hasAppReceived === true ? (
                        <div style={styles.div}>
                          <HeaderMenu />
                          <Sidebar.Pushable style={styles.pushable}>
                            <SidebarMenu
                              routes={routes}
                              setRoutes={setRoutes}
                            />
                            <Sidebar.Pusher style={styles.pusher}>
                              <Switch>
                                {routes.map((r, i) => (
                                  <Route
                                    exact
                                    key={i}
                                    path={r.page.path}
                                    component={r.component}
                                  />
                                ))}
                                <Redirect
                                  to={{
                                    pathname: "/error",
                                    state: { message: "404" },
                                  }}
                                />
                              </Switch>
                            </Sidebar.Pusher>
                          </Sidebar.Pushable>
                          {isToastOn ? (
                            <ToastContainer
                              autoClose={false}
                              onClick={toastOnClick}
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      ) : null
                    }
                  />
                </>
              ) : (
                <>
                  {authState !== "signedIn" ? (
                    <>
                      <Redirect exact from="/" to={Sign_In.path} />
                      <Route path={Sign_In.path} component={SignIn} />
                    </>
                  ) : (
                    <>
                      {ppid === 0 ? (
                        <>
                          <Redirect exact from="/" to="/ChoosePPLT" />
                          <Route path="/ChoosePPLT" component={PPLTDropDown} />
                        </>
                      ) : (
                        <>
                          <Redirect
                            exact
                            from="/"
                            to={Plant_Overview_COMMON.path}
                          />
                          <Route
                            render={() =>
                              routes.length > 0 && hasAppReceived === true ? (
                                <div style={styles.div}>
                                  <HeaderMenu key={ppid} ppid={ppid} />
                                  <Sidebar.Pushable style={styles.pushable}>
                                    <SidebarMenu routes={routes} />
                                    <Sidebar.Pusher style={styles.pusher}>
                                      <Switch>
                                        {routes.map((r, i) => (
                                          <Route
                                            exact
                                            key={i}
                                            path={r.page.path}
                                            component={r.component}
                                          />
                                        ))}
                                        <Redirect
                                          to={Plant_Overview_COMMON.path}
                                        />
                                        <Redirect
                                          to={{
                                            pathname: "/error",
                                            state: { message: "404" },
                                          }}
                                        />
                                      </Switch>
                                    </Sidebar.Pusher>
                                  </Sidebar.Pushable>
                                  {isToastOn ? (
                                    <ToastContainer
                                      autoClose={false}
                                      onClick={toastOnClick}
                                    />
                                  ) : (
                                    ""
                                  )}
                                </div>
                              ) : null
                            }
                          />
                        </>
                      )}
                    </>
                  )}
                </>
              )}
            </Switch>
          </HashRouter>
        </>
      )}
    </>
  );
};

const styles = {
  div: {
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  pushable: {
    flex: "auto",
    display: "flex",
    flexDirection: "column",
  },
  pusher: {
    flex: "auto",
    padding: "14px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
};

const mapDispatchToProps = (dispatch) => {
  return {
    setHasAppReceived: (hasAppReceived) =>
      dispatch(setHasAppReceived(hasAppReceived)),
    setHeaderValues: (headerValues) => dispatch(setHeaderValues(headerValues)),
    setModel: (model) => dispatch(setModel(model)),
    setHasHeaderReceived: (hasHeaderReceived) =>
      dispatch(setHasHeaderReceived(hasHeaderReceived)),
    showSidebar: () => dispatch(showSidebarMenu()),
    setUser: (user) => dispatch(setUser(user)),
  };
};

const mapStateToProps = (state) => {
  return {
    hasAppReceived: state.header.hasAppReceived,
    headerValues: state.header.headerValues,
    hasHeaderReceived: state.header.hasHeaderReceived,
    sidebarVisible: state.nav.sidebarMenuVisible,
    model: state.header.model,
    user: state.nav.user,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(React.memo(App));
